import Layout from '../../components/layout/Layout';
import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Link, Stack, Typography } from '@mui/material';
import { LocationOn, AccessTime, Phone, Email, SquareFoot } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export default function Contact() {

    const salonsData = [
        {
            key: 'minsk',
            title: 'Mińsk Mazowiecki',
            sub: 'Stojadła, ul. Warszawska 93/95 • 05-300',
            headerBg: 'linear-gradient(135deg, #2b32b2 0%, #1488cc 100%)',
            headerColor: '#fff',
            accent: '#1488cc',
            area: '10 000 m²',
            mapSrc:
                'https://maps.google.com/maps?q=UFO%20Salon%20meblowy%20Mi%C5%84sk%20Mazowiecki&hl=pl&z=13&output=embed',
            hoursTop: 'Pn–Pt 10:00–18:00',
            hoursSat: 'Sob 10:00–14:00',
            phone: { text: '602 631 217', href: 'tel:602631217' },
            email: { text: 'biuro@ufo-meble.pl', href: 'mailto:biuro@ufo-meble.pl' },
            extra: [
                { icon: 'phone', text: '25 759 62 40', href: 'tel:257596240' },
                { icon: 'email', text: 'reklamacje@ufo-meble.pl', href: 'mailto:reklamacje@ufo-meble.pl' },
            ],
            navHref: 'https://maps.app.goo.gl/ewqntGgU3MxUfrEU9',
        },
        {
            key: 'warszawa',
            title: 'Warszawa',
            sub: 'Ul. Grochowska 129 • 04-148',
            headerBg: 'linear-gradient(135deg, #7b4397 0%, #dc2430 100%)',
            headerColor: '#fff',
            accent: '#dc2430',
            area: '1 500 m²',
            mapSrc:
                'https://maps.google.com/maps?q=UFO%20MEBLE%20GROCHOWSKA%20WARSZAWA&hl=pl&z=13&output=embed',
            hoursTop: 'Pn–Pt 10:00–19:00',
            hoursSat: 'Sob 10:00–15:00',
            phone: { text: '604 485 537', href: 'tel:604485537' },
            email: { text: 'biuro1@ufo-meble.pl', href: 'mailto:biuro1@ufo-meble.pl' },
            // Dział reklamacji taki sam jak w Mińsku
            extra: [
                { icon: 'phone', text: '25 759 62 40', href: 'tel:257596240' },
                { icon: 'email', text: 'reklamacje@ufo-meble.pl', href: 'mailto:reklamacje@ufo-meble.pl' },
            ],
            navHref: 'https://maps.app.goo.gl/p2qo5CBoLXuQfPMR6',
        },
        {
            key: 'piaseczno',
            title: 'Piaseczno',
            sub: 'plac Piłsudskiego 6 • 05-500',
            headerBg: 'linear-gradient(135deg, #232526 0%, #6a6b6bff 100%)',
            headerColor: '#fff',
            accent: '#414345',
            area: '4 000 m²',
            mapSrc:
                'https://maps.google.com/maps?q=SALON%20MEBLOWY%20UFO%20MEBLE%20Piaseczno&hl=pl&z=13&output=embed',
            hoursTop: 'Pon 12:00–20:00\nWt–Pt 10:00–18:00',
            hoursSat: 'Sob 10:00–14:00',
            phone: { text: '506 003 090', href: 'tel:506003090' },
            email: { text: 'ufopiaseczno@wp.pl', href: 'mailto:ufopiaseczno@wp.pl' },
            extra: [],
            navHref: 'https://maps.app.goo.gl/b6zTLxwxDuSyjMsK8',
        },
    ] as const;

    return (
        <Layout title='Kontakt'>
            <Box sx={{ px: 2, py: 4 }}>
                {/* Kontener nadrzędny 100% z centrowaniem */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    {/* Kontener wewnętrzny z space-around i wrapem */}
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-around',
                            alignItems: 'stretch',
                            gap: 3,
                        }}
                    >
                        {salonsData.map((s) => (
                            <Card
                                key={s.key}
                                sx={{
                                    width: 400,            // stała szerokość dla wszystkich kart
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    boxShadow: 8,
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <CardHeader
                                    title={s.title}
                                    subheader={s.sub}
                                    sx={{
                                        background: s.headerBg,
                                        color: s.headerColor,
                                        '& .MuiCardHeader-subheader': {
                                            color: s.headerColor === '#fff' ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.75)',
                                        },
                                    }}
                                    avatar={
                                        <Avatar sx={{ bgcolor: 'rgba(255,255,255,.25)' }}>
                                            <LocationOn sx={{ color: s.headerColor }} />
                                        </Avatar>
                                    }
                                />

                                <Box sx={{ height: 220, overflow: 'hidden' }}>
                                    <iframe
                                        title={`mapa ${s.key}`}
                                        width="100%"
                                        height="100%"
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src={s.mapSrc}
                                    />
                                </Box>

                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Stack spacing={1.25}>
                                        <Stack direction="row" spacing={1.25} alignItems="center">
                                            <AccessTime color="primary" />
                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                {s.hoursTop}
                                                <br />
                                                {s.hoursSat}
                                            </Typography>
                                        </Stack>

                                        {/* Powierzchnia pod godzinami */}
                                        <Stack direction="row" spacing={1.25} alignItems="center">
                                            <SquareFoot color="action" />
                                            <Typography variant="body2">{s.area}</Typography>
                                        </Stack>

                                        <Divider />
                                        <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>
                                            Obsługa klienta
                                        </Typography>
                                        <Stack direction="row" spacing={1.25} alignItems="center">
                                            <Phone color="action" />
                                            <Link href={s.phone.href} underline="hover">
                                                {s.phone.text}
                                            </Link>
                                        </Stack>
                                        <Stack direction="row" spacing={1.25} alignItems="center">
                                            <Email color="action" />
                                            <Link href={s.email.href} underline="hover">
                                                {s.email.text}
                                            </Link>
                                        </Stack>

                                        {(s.extra.length > 0) && (
                                            <>
                                                <Divider />
                                                <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>
                                                    Dział reklamacji
                                                </Typography>

                                                {/* Mały guzik do reklamacji online (tylko Mińsk i Warszawa) */}
                                                {(s.key === 'minsk' || s.key === 'warszawa') && (
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        component={RouterLink}
                                                        to="/reklamacja"
                                                        sx={{
                                                            alignSelf: 'flex-start',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            boxShadow: 'none',
                                                            borderRadius: 2,
                                                            fontWeight: 700,
                                                            textTransform: 'none',
                                                            px: 1.25,
                                                            '&:hover': { backgroundColor: '#fff', boxShadow: 'none', filter: 'brightness(0.98)' },
                                                        }}
                                                    >
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                display: 'inline-block',
                                                                backgroundImage: s.headerBg,
                                                                backgroundClip: 'text',
                                                                WebkitBackgroundClip: 'text',
                                                                color: 'transparent',
                                                                WebkitTextFillColor: 'transparent',
                                                            }}
                                                        >
                                                            Złóż reklamację online
                                                        </Box>
                                                    </Button>
                                                )}

                                                {s.extra.map(
                                                    (
                                                        e: { icon: 'phone' | 'email'; text: string; href: string },
                                                        i: number
                                                    ) => (
                                                        <Stack key={i} direction="row" spacing={1.25} alignItems="center">
                                                            {e.icon === 'phone' ? <Phone color="action" /> : <Email color="action" />}
                                                            <Link href={e.href} underline="hover">
                                                                {e.text}
                                                            </Link>
                                                        </Stack>
                                                    )
                                                )}
                                            </>
                                        )}
                                    </Stack>
                                </CardContent>

                                <CardActions sx={{ px: 2, pb: 2, pt: 1, gap: 1, justifyContent: 'space-between' }}>
                                    {/* Kolorowy (gradient) guzik Nawiguj */}
                                    <Button
                                        variant="contained"
                                        component="a"
                                        href={s.navHref}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            color: '#fff',
                                            backgroundImage: s.headerBg,
                                            boxShadow: 'none',
                                            transition: 'filter 0.3s ease, box-shadow 0.3s ease',
                                            '&:hover': { filter: 'brightness(1.45)', boxShadow: 'none' },
                                        }}
                                    >
                                        Nawiguj
                                    </Button>
                                </CardActions>
                            </Card>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Layout>
    );
}